import * as tslib_1 from "tslib";
import confirmItemActionAllowed from '../utils/confirmItemActionAllowed';
import getLatestNonDraftItemIdFromConversation from '../utils/getLatestNonDraftItemIdFromConversation';
import { lazyReplyToMessage } from 'owa-mail-compose-store';
import * as mailModuleOrchestrator from 'owa-mail-module-orchestrator';
import { format } from 'owa-strings';
import strings from 'owa-strings/owa-mail-strings';
import { action } from 'satcheljs/lib/legacy';
export default action('replyToConversation')(function replyToConversation(conversationId, isReplyAll, actionSource, instrumentationContexts, isFullCompose, initialComposeLogTraceId) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var referenceItemId, restrictionToConfirm;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getLatestNonDraftItemIdFromConversation(conversationId)];
                case 1:
                    referenceItemId = _a.sent();
                    if (referenceItemId && referenceItemId.Id) {
                        restrictionToConfirm = {
                            ReplyAllAllowed: isReplyAll,
                            ReplyAllowed: !isReplyAll,
                        };
                        if (confirmItemActionAllowed(referenceItemId.Id, restrictionToConfirm, format(strings.irm_actionNotAllowedOnThisConversation, isReplyAll ? strings.itemHeaderReplyAll : strings.itemHeaderReply))) {
                            lazyReplyToMessage.importAndExecute(referenceItemId, isReplyAll, isFullCompose, actionSource, instrumentationContexts, isFullCompose ? null : conversationId.Id, undefined /* body */, undefined /* fullComposeTarget */, undefined /* attachmentFiles */, initialComposeLogTraceId);
                            mailModuleOrchestrator.lazyOnReplyOrReplyAllOrForwardMessage.importAndExecute();
                        }
                    }
                    return [2 /*return*/];
            }
        });
    });
});
//# sourceMappingURL=replyToConversation.js.map